export default {
  labels: {
    today: 'Tänään',
    pickup_time: 'Noutoaika',
    delivery_time: 'Toimitusaika',
  },
};
